import { render, staticRenderFns } from "./userCollaborationsList.vue?vue&type=template&id=6624e75e"
import script from "./userCollaborationsList.vue?vue&type=script&lang=js"
export * from "./userCollaborationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports